
























import cartData from 'library/mixins/cart-data'

export default
	mixins: [ cartData ]

	methods:

		# Fire 'Checkout clicked' GTM event
		onCheckout: ->
			@$gtm.push
				event: @$GTM_EVENTS.CHECKOUT_CLICKED
				component: @$GTM_COMPONENTS.CART_PAGE

